























import { PropType } from 'vue';
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, AdgroupConfig } from '@tt4b/ttam-enums';
import TtamCopyBatchWrap from '@/components/common/batch-wrap/index.vue';
import Network from './index';

const name = 'ttam-network-compose';
export default defineComponent({
  name,
  components: {
    TtamNetwork: Network.TtamNetwork,
    TtamCopyBatchWrap,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    batchFormData: {
      type: Array as PropType<Partial<AdgroupFormData>[]>,
      default: () => [],
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData } = toRefs(props);
    const _network = computed({
      get: () => adgroupData.value.ac,
      set: val => {
        emit('change', val);
      },
    });
    const { networkOptions } = Network.useNetworkOptions();
    const onAdgroupDataChange = data => {
      emit('adgroupDataChange', data);
    };
    const onCopyDataChange = data => {
      emit('copyDataChange', data);
    };
    return {
      name,
      _network,
      networkOptions,
      onAdgroupDataChange,
      onCopyDataChange,
    };
  },
});
